import { render } from "./TabsModalImovel.vue?vue&type=template&id=ab8c6b1c"
import script from "./TabsModalImovel.vue?vue&type=script&lang=js"
export * from "./TabsModalImovel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__